var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 22H12C9.79086 22 8 20.2091 8 18L8 12.75L15 12.75C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25L8 11.25V6C8 3.79086 9.79086 2 12 2H17C19.2091 2 21 3.79086 21 6L21 8V16V18C21 20.2091 19.2091 22 17 22ZM8 11.25H3.81066L5.53033 9.53033C5.82322 9.23744 5.82322 8.76256 5.53033 8.46967C5.23744 8.17678 4.76256 8.17678 4.46967 8.46967L2.17678 10.7626C1.49336 11.446 1.49336 12.554 2.17678 13.2374L4.46967 15.5303C4.76256 15.8232 5.23744 15.8232 5.53033 15.5303C5.82322 15.2374 5.82322 14.7626 5.53033 14.4697L3.81066 12.75H8V11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.22d5158ca25b6609a9ef890344a3bb03.svg";
export { ForwardRef as ReactComponent };